import * as React from 'react';

export function SvgGoogleSlides(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_174)">
        <path
          d="M18.6875 22H5.3125C4.59062 22 4 21.3864 4 20.6364V3.36364C4 2.61364 4.59062 2 5.3125 2H15.1875L20 7V20.6364C20 21.3864 19.4094 22 18.6875 22Z"
          fill="#F8BF08"
        />
        <path d="M15.1874 2L19.9999 7H15.1874V2Z" fill="#F59307" />
        <path
          d="M7.28577 9.84415V16.7013H16.7143V9.84415H7.28577ZM15.5358 15.4768H8.46434V11.0686H15.5358V15.4768Z"
          fill="#FDFFFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_14_174">
          <rect
            width="16"
            height="20"
            fill="white"
            transform="translate(4 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
